<template>
	<div>
		<div :class="'lineups'+matchId"></div>
		<div :class="'probablity_'+matchId"></div>
		<div :class="'headvhead_'+matchId"></div>
		<div :class="'teamleaderboard_'+matchId"></div>

		<div class="row">
			<div class="col-4">
				<div :class="'sr_season_liveTable'+matchId"></div>
			</div>
			<div class="col-4">
				<div :class="'toplists'+matchId"></div>
			</div>
			<div class="col-4">
				<div :class="'sr_season_liveTable2'+matchId"></div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: "matchDetail",
        props: {
            matchId: {
                default: 0
            },
            collapseTo: {
                type: String,
                default: 'disable'
            },
            layout: {
                type: String,
                default: 'single'
            },
        },
        watch: {
            'matchId' () {
                this.sportWidget()
            }
        },
        destroy () {
            this.matchId = null;
            SIR = null;
        },
        mounted () {

            (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
                    g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
            )})(window,document,"script", "/static/sir/widgetloader.js", "SIR", {
                theme: false, // using custom theme
                language: 'tr'
            });

            this.sportWidget()

        },
        methods:{
            sportWidget(){

                SIR("addWidget", ".lineups"+this.matchId, "mx.match.lineups", {showOdds:false,adsFrequency:false,collapseTo: this.collapseTo,layout: this.layout, detailedScoreboard: "enable", language: window.userLang, matchId: this.matchId});

                SIR("addWidget", ".headvhead_"+this.matchId, "match.headToHead", {showOdds:false,adsFrequency:false,collapseTo: this.collapseTo,layout: this.layout, detailedScoreboard: "enable", language: window.userLang, matchId: this.matchId});
                SIR("addWidget", ".probablity_"+this.matchId, "match.winProbability", {showOdds:false, language: window.userLang, matchId: this.matchId});
                SIR("addWidget", ".teamleaderboard_"+this.matchId, "team.leaderboard", {showOdds:false, language: window.userLang, matchId: this.matchId});

                SIR("addWidget", ".sr_season_liveTable"+this.matchId, "season.liveTable", {showOdds:false, language: window.userLang, matchId: this.matchId});
                SIR("addWidget", ".toplists"+this.matchId, "season.toplists", {showOdds:false, language: window.userLang, matchId: this.matchId});
                SIR("addWidget", ".sr_season_liveTable2"+this.matchId, "match.generalStatistics", {showOdds:false, detailedScoreboard: "disable", language: window.userLang, matchId: this.matchId});
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/stats/widget/matchDetail.vue